module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogVisible,
      "size": "small",
      "before-close": _vm.closeCallback
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "model": _vm.KingdeeAddForm,
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.opts.title + '金额'
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.KingdeeAddForm.ParagraphAmount),
      callback: function($$v) {
        _vm.$set(_vm.KingdeeAddForm, "ParagraphAmount", $$v)
      },
      expression: "KingdeeAddForm.ParagraphAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.KingdeeAddForm.Remark),
      callback: function($$v) {
        _vm.$set(_vm.KingdeeAddForm, "Remark", $$v)
      },
      expression: "KingdeeAddForm.Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeCallback
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.KingdeeAdd
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-abd36c64!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMAgentAccountManage/components/returnMoney/index.vue
// module id = 1553
// module chunks = 1